import React, { useState, useEffect } from 'react';

const Countdown = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="countdown-container" style={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center', marginTop: '20px'}}>
      <div className="time-section" style={{ textAlign: 'center',width: '96px', height: '96px', backgroundColor: 'var(--white)', borderRadius: '6px', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
        <div className="number" style={{fontSize: '32px', fontWeight: '400', lineHeight: '120%', color: 'var(--primary)'}}> {timeLeft.days} </div>
        <div className="label" style={{fontSize: '14px', fontWeight: '400', color: 'var(--greenG5)', marginTop: '4px'}}>DAYS</div>
      </div>
      :
      <div className="time-section" style={{ textAlign: 'center',width: '96px', height: '96px', backgroundColor: 'var(--white)', borderRadius: '6px', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
        <div className="number" style={{fontSize: '32px', fontWeight: '400', lineHeight: '120%', color: 'var(--primary)'}}>{timeLeft.hours}</div>
        <div className="label" style={{fontSize: '14px', fontWeight: '400', color: 'var(--greenG5)', marginTop: '4px'}}>HOURS</div>
      </div>
      :
      <div className="time-section" style={{ textAlign: 'center',width: '96px', height: '96px', backgroundColor: 'var(--white)', borderRadius: '6px', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
        <div className="number" style={{fontSize: '32px', fontWeight: '400', lineHeight: '120%', color: 'var(--primary)'}}>{timeLeft.minutes}</div>
        <div className="label" style={{fontSize: '14px', fontWeight: '400', color: 'var(--greenG5)', marginTop: '4px'}}>MINS</div>
      </div>
      :
      <div className="time-section" style={{ textAlign: 'center',width: '96px', height: '96px', backgroundColor: 'var(--white)', borderRadius: '6px', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
        <div className="number" style={{fontSize: '32px', fontWeight: '400', lineHeight: '120%', color: 'var(--primary)'}}>{timeLeft.seconds}</div>
        <div className="label" style={{fontSize: '14px', fontWeight: '400', color: 'var(--greenG5)', marginTop: '4px'}}>SECS</div>
      </div>
    </div>
  );
};

export default Countdown;